import * as React from 'react'
import { AccessPills } from '@/components/visitone/access-status'
import { PageHeader } from '@/components/visitone/page-header'
import { SectionedForm } from '@/components/visitone/sectioned-form'
import { useT } from '@/components/visitone/visitone-provider'
import { orderTypeDefinition, orderTypeInitialValues } from '@/components/visitone/surfaces/order-type-form'
import { useAccess } from '@/hooks/use-access'
import { orderTypeFixture } from '@/lib/fixtures'
import { pathForDestination } from '@/lib/routing'

/* Synthetic fixture: there is no Order types BFF operation yet, so a save only waits. */
const saveFixture = () => new Promise<void>((resolve) => window.setTimeout(resolve, 650))

export function OrderTypeSurface() {
  const t = useT()
  const definition = React.useMemo(() => orderTypeDefinition(t), [t])
  const [initialValues] = React.useState(() => orderTypeInitialValues(definition))
  const name = orderTypeFixture.identity.displayName
  const { pageStatus, tenantName, canOpenSetupHome } = useAccess()
  const status = pageStatus('setup')

  return (
    <div className="flex flex-col">
      <PageHeader
        breadcrumb={[
          { label: t('setup.title'), to: canOpenSetupHome ? pathForDestination('setup') : undefined },
          t('orderTypes.area'),
          t('orderTypes.topics.orderTypes'),
          name,
        ]}
        title={name}
        status={<AccessPills status={status} />}
        summary={
          status.summary === 'viewOnly'
            ? t('core.access.viewOnlyNote', { tenant: tenantName })
            : t('orderTypes.configuration')
        }
      />
      <SectionedForm
        definition={definition}
        initialValues={initialValues}
        subject={name}
        onSave={saveFixture}
        readOnly={status.readOnly}
      />
    </div>
  )
}
